export const boostedCatalogQueryKeys = {
  all: ['boostedCatalog'] as const,
};
